var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var LogoutIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 64
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0C32.167 0 32.3337 0.0012649 32.5 0.00378567V5.60469C32.3337 5.60157 32.167 5.6 32 5.6C17.4667 5.6 5.60002 17.4667 5.60002 32C5.60002 46.5334 17.4667 58.4 32 58.4C32.167 58.4 32.3337 58.3985 32.5 58.3953V63.9962C32.3337 63.9988 32.167 64 32 64C14.2667 64 0 49.7334 0 32C0 14.2667 14.2667 0 32 0ZM63.219 29.6683L50.807 17.2557C49.7656 16.2143 48.0772 16.2143 47.0358 17.2557C45.9944 18.2971 45.9944 19.9855 47.0358 21.0269L54.8954 28.8872L20 28.8872V34.2206H54.8954L47.0358 42.0802C45.9944 43.1216 45.9944 44.8101 47.0358 45.8515C48.0772 46.8929 49.7656 46.8929 50.807 45.8515L63.219 33.4395C64.2604 32.3981 64.2604 30.7097 63.219 29.6683Z"
  }));
};
export var LogoutIconGlyph = function (props) {
  return React.createElement(LogoutIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};